export default __webpack_public_path__ + "static/media/quantisal_step9.bd922a7d.png";